/**
 * Spacing Control
 *
 * Adds the functionality for the spacing control
 *
 * @author      Christopher Tousignant <christopher.tousignant@nichols.edu>
 * @package     NicholsCollege
 * @since       1.0.0
 */

import $ from 'jquery';

/**
 * Default export
 *
 * Exports a closure so the component automatically gets
 * attached to jQuery's prototype and can immediately
 * be consumed
 */
export default ( ( $ ) => {

    /**
     * Defaults to be used
     */
    let pluginName = 'style_attributes',
        prototypeName = `plugin_${pluginName}`,
        defaults =
            {
                names : [ 'typography', 'color' ],
                type : 'classes',
                target : 'all',
            };

    /**
     * Plugin Ctor
     *
     * @param element
     * @param options
     * @constructor
     */
    function Style_Attributes( element, options )
    {
        this.element =              element;
        this.$element =             $( element );
        this.options =              $.extend( {}, defaults, options );
        this._defaults =            defaults;
        this._name =                pluginName;

        this.init();
    }

    /**
     * Plugin Prototype
     */
    Style_Attributes.prototype =
        {
            /**
             * Init
             *
             * On initialization, check what the classes or styles should
             * be applied to and then apply them.
             *
             * @access  public
             * @since   1.0.0
             * @return  void
             */
            init : function()
            {
                let children = this.$element.find( '*' );

                /**
                 * Should we target all of the elements children or the
                 * element itself.
                 */
                if( this.options.target == 'all' )
                {
                    $.each( children, ( function( index, child ) {
                        if( this.options.type == 'classes' )
                            this.addClasses( child );

                        else if( this.options.type == 'styles' )
                            this.addStyles( child );

                    } ).bind( this ) )
                }
                else
                {
                    if( this.options.type == 'classes' )
                        this.addClasses( this.element );

                    else if( this.options.type == 'styles' )
                        this.addStyles( this.element );
                }
            },

            /**
             * addClasses
             *
             * Add the options as classes to the passed element
             *
             * @access  public
             * @param   object child The element to add the styles too
             * @return  void
             * @since   1.0.0
             */
            addClasses : function( child )
            {
                let values = '';

                $.each( this.options.names, ( function( index, name ) {
                    let value = this.$element.data( name );

                    if( value )
                    {
                        values += value + " ";
                    }
                } ).bind( this ) );

                $( child ).addClass( values );
            },

            /**
             * addStyles
             *
             * Add the options as inline styles
             *
             * @access  public
             * @param   object child The element to attach the inline styles too
             * @since   1.0.0
             * @return  void
             */
            addStyles : function( child )
            {
                $.each( this.options.names, ( function( index, name ) {
                    let values = '';
                    let value = this.$element.data( name );

                    if( value )
                    {
                        $( child ).css( name, value );
                    }
                } ).bind( this ) );
            }

        }

    /**
     * Attach the plugin to the jQuery prototype
     *
     * @param options
     * @returns {*}
     */
    $.fn[ pluginName ] = function( options )
    {
        return $.each( this, function( index, element ) {
            if ( ! $.data( element, prototypeName ) ){
                $.data( element, prototypeName , new Style_Attributes( element, options ));
            }
        } )
    };

} )( $.noConflict() );